import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IPaginationQueryInfo } from 'types/pagination'
import { IVideoInstruction, IVideoInstructions } from 'types/video-instructions'

export const videoInstructionsApi = createApi({
  reducerPath: 'videos',
  baseQuery,
  tagTypes: ['Videos'],
  endpoints: (builder) => ({
    videoInstructions: builder.query<IVideoInstructions, IPaginationQueryInfo>({
      query: ({ page, size }) => {
        return {
          url: '/videos',
          method: 'get',
          params: {
            page,
            size,
          },
        }
      },
      providesTags: ['Videos'],
    }),

    videoInstruction: builder.query<IVideoInstruction, IdParams>({
      query: ({ id }) => `/videos/${id}`,
    }),

    createVideoInstruction: builder.mutation<void, Partial<IVideoInstruction>>({
      query: (body) => ({
        url: `/videos`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['Videos'],
    }),

    deleteVideoInstruction: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/videos/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Videos'],
    }),
  }),
})

export const {
  useVideoInstructionsQuery,
  useVideoInstructionQuery,
  useDeleteVideoInstructionMutation,
  useCreateVideoInstructionMutation,
} = videoInstructionsApi
